<template>
  <form @submit="sendResetLink" style="max-width: 500px; width: 100%;">
    <Alert type="danger" :messages="errors"/>
    <Alert type="success" :messages="messages"/>

    <Loader v-if="loading" />
    <div class="login-container" v-else>
      <p>ご登録のメールアドレスを入力してください。<br/>
パスワード再設定のご案内メールをお送りいたします。</p>
      <div class="form-group custom-form-group">
        <label for="email">メールアドレス</label>
          <input type="email" v-model="email" class="form-control" name="email"
            v-validate="'required|email'" data-vv-as="メールアドレス" id="email">
            <FieldError :message="formErrors.first('email')" />
      </div>
      <!-- <div class="mb-30">
        <router-link to="/" class="forgot-link">
          Back to Login
        </router-link>
      </div>
      <div class="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups">
        <button class="btn btn-primary" type="submit" :disabled="!validForm">
          Send Verification Link
        </button>
      </div> -->
      <div class="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups">
        <router-link to="/" class="btn btn-outline-danger  me-1">キャンセル</router-link>
        <button type="submit" class="btn btn-primary" :disabled="!validForm">送信</button>
      </div>
    </div><!-- ends custom-form-block -->
  </form>
</template>

<script>
import Alert from '@/components/utils/Alert.vue';
import FieldError from '@/components/utils/FieldError.vue';
import Loader from '@/components/utils/Loader.vue';
import Api from '@/config/api';
import axios from '@/http';
export default {
  name: 'Password',
  components: { Loader, FieldError, Alert },
  data() {
    return {
      errors: [],
      messages: [],
      email: '',
      loading: false,
    };
  },
  mounted() {
    const emailInput = document.getElementById('email');
    emailInput.focus();
  },
  computed: {
    validForm() {
      const { email } = this.Vfields;
      if (email) return email.changed && this.formErrors.count() === 0;
      return false;
    },
  },
  methods: {
    sendResetLink(event) {
      event.preventDefault();
      if (!this.validForm) return false;
      this.errors = [];
      this.messages = [];
      this.loading = true;
      return axios.post(Api.endpoints.FORGOT_PASSWORD, { email: this.email })
        .then((res) => {
                console.log(res)
               const msg = res.data.data.message?res.data.data.message:'メールを送信しました';
          this.messages.push(msg);
          this.email = '';
        })
        .catch(({ response }) => {
          this.parseErrorResponse(response);
        })
        .then(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>

  label {
    color: #617776;
    font-weight: bold;
  }
  .custom-group {
    border: 1px solid #ced4da;
  }
  .custom-form-group .is-valid  {
    background-image: none!important;
  }

  .btn-toolbar {
    justify-content: space-evenly;
  }

  .custom-form-group .is-invalid {
    background-image: none!important;
  }
</style>